import React from 'react'

const Smsung5 = () => {
    return (
        <div>
          <div className='container'>
            <h1>Find the middle of a given linked list</h1>
            <p>Given a singly linked list, find the middle of the linked list. For example, if the given linked list is 1-&gt;2-&gt;3-&gt;4-&gt;5 then the output should be 3.&nbsp;<br/>
            If there are even nodes, then there would be two middle nodes, we need to print the second middle element. For example, if given linked list is 1-&gt;2-&gt;3-&gt;4-&gt;5-&gt;6 then the output should be 4.&nbsp;</p>
            <p><strong>Solution:</strong>&nbsp;<br/>Traverse linked list using two pointers. Move one pointer by one and the other pointers by two. When the fast pointer reaches the end slow pointer will reach the middle of the linked list.</p>
              
                   <div class="tabs">
    <input type="radio" name="tab" id="tab1"/>
    <label for="tab1">CPP</label>
    <input type="radio" name="tab" id="tab2"/>
    <label for="tab2">Java </label>
    <input type="radio" name="tab" id="tab3"/>
    <label for="tab3">Python</label>
    <input type="radio" name="tab" id="tab4"/>
    <label for="tab4">C</label>
  
    <div class="tab-content-wrapper">
      <div id="tab-content-1" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C++ program for the above approach</code></div>
    <div class="line number2 index1 alt1">&nbsp;</div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;iostream&gt;</code></div>
    <div class="line number4 index3 alt1"><code class="keyword bold">using</code> <code
            class="keyword bold">namespace</code> <code class="plain">std;</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="keyword bold">class</code> <code class="plain">Node&#123;</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">public</code><code class="plain">:</code></div>
    <div class="line number8 index7 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">data;</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node *next;</code></div>
    <div class="line number10 index9 alt1"><code class="plain">&#125;;</code></div>
    <div class="line number11 index10 alt2">&nbsp;</div>
    <div class="line number12 index11 alt1"><code class="keyword bold">class</code> <code
            class="plain">NodeOperation&#123;</code></div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keyword bold">public</code><code class="plain">:</code></div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Function to add a new node</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">void</code> <code class="plain">pushNode(</code><code class="keyword bold">class</code>
        <code class="plain">Node** head_ref,</code><code class="color1 bold">int</code> <code
            class="plain">data_val)&#123;</code></div>
    <div class="line number17 index16 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number18 index17 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Allocate node</code></div>
    <div class="line number19 index18 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">class</code> <code class="plain">Node *new_node = </code><code
            class="keyword bold">new</code> <code class="plain">Node();</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Put in the data</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node-&gt;data = data_val;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// Link the old list off the new node</code></div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node-&gt;next = *head_ref;</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// move the head to point to the new node</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">*head_ref = new_node;</code></div>
    <div class="line number29 index28 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">// A utility function to print a given linked list</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">void</code> <code class="plain">printNode(</code><code
            class="keyword bold">class</code> <code class="plain">Node *head)&#123;</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code><code class="plain">(head != NULL)&#123;</code></div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt;head-&gt;data &lt;&lt; </code><code class="string">"-&gt;"</code><code
            class="plain">;</code></div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">head = head-&gt;next;</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number37 index36 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"NULL"</code> <code
            class="plain">&lt;&lt; endl;</code></div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">void</code> <code class="plain">printMiddle(</code><code
            class="keyword bold">class</code> <code class="plain">Node *head)&#123;</code></div>
    <div class="line number41 index40 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node *slow_ptr = head;</code></div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node *fast_ptr = head;</code></div>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(head!=NULL)</code></div>
    <div class="line number45 index44 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number46 index45 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code
            class="plain">(fast_ptr != NULL &amp;&amp; fast_ptr-&gt;next != NULL)</code></div>
    <div class="line number47 index46 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number48 index47 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">fast_ptr = fast_ptr-&gt;next-&gt;next;</code></div>
    <div class="line number49 index48 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">slow_ptr = slow_ptr-&gt;next;</code></div>
    <div class="line number50 index49 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number51 index50 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"The middle element is ["</code> <code
            class="plain">&lt;&lt; slow_ptr-&gt;data &lt;&lt; </code><code class="string">"]"</code> <code
            class="plain">&lt;&lt; endl;</code></div>
    <div class="line number52 index51 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number54 index53 alt1"><code class="plain">&#125;;</code></div>
    <div class="line number55 index54 alt2">&nbsp;</div>
    <div class="line number56 index55 alt1"><code class="comments">// Driver Code</code></div>
    <div class="line number57 index56 alt2"><code class="color1 bold">int</code> <code class="plain">main()&#123;</code>
    </div>
    <div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">class</code> <code class="plain">Node *head = NULL;</code></div>
    <div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">class</code> <code class="plain">NodeOperation *temp = </code><code
            class="keyword bold">new</code> <code class="plain">NodeOperation();</code></div>
    <div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code><code class="plain">(</code><code class="color1 bold">int</code> <code
            class="plain">i=5; i&gt;0; i--)&#123;</code></div>
    <div class="line number61 index60 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp-&gt;pushNode(&amp;head, i);</code></div>
    <div class="line number62 index61 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp-&gt;printNode(head);</code></div>
    <div class="line number63 index62 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">temp-&gt;printMiddle(head);</code></div>
    <div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number66 index65 alt1"><code class="plain">&#125;</code></div>
</div>
      </div>
      <div id="tab-content-2" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// Java program to find middle of linked list</code>
    </div>
    <div class="line number2 index1 alt1"><code class="keyword">class</code> <code class="plain">LinkedList</code></div>
    <div class="line number3 index2 alt2"><code class="plain">&#123;</code></div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node head; </code><code class="comments">// head of linked list</code></div>
    <div class="line number5 index4 alt2">&nbsp;</div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Linked list node */</code></div>
    <div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">class</code> <code class="plain">Node</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number9 index8 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">int</code> <code class="plain">data;</code></div>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node next;</code></div>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node(</code><code class="keyword">int</code> <code class="plain">d)</code></div>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">data = d;</code></div>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">next = </code><code class="keyword">null</code><code class="plain">;</code></div>
    <div class="line number15 index14 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number17 index16 alt2">&nbsp;</div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Function to print middle of linked list */</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">void</code> <code class="plain">printMiddle()</code></div>
    <div class="line number20 index19 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node slow_ptr = head;</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node fast_ptr = head;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">if</code> <code class="plain">(head != </code><code class="keyword">null</code><code
            class="plain">)</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">(fast_ptr != </code><code class="keyword">null</code> <code
            class="plain">&amp;&amp; fast_ptr.next != </code><code class="keyword">null</code><code
            class="plain">)</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">fast_ptr = fast_ptr.next.next;</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">slow_ptr = slow_ptr.next;</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"The middle element is ["</code> <code
            class="plain">+</code></div>
    <div class="line number31 index30 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">slow_ptr.data + </code><code class="string">"] \n"</code><code class="plain">);</code></div>
    <div class="line number32 index31 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number34 index33 alt1">&nbsp;</div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Inserts a new Node at front of the list. */</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">void</code> <code class="plain">push(</code><code
            class="keyword">int</code> <code class="plain">new_data)</code></div>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* 1 &amp; 2: Allocate the Node &amp;</code></div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">Put in the data*/</code></div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node new_node = </code><code class="keyword">new</code> <code
            class="plain">Node(new_data);</code></div>
    <div class="line number41 index40 alt2">&nbsp;</div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* 3. Make next of new Node as head */</code></div>
    <div class="line number43 index42 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node.next = head;</code></div>
    <div class="line number44 index43 alt1">&nbsp;</div>
    <div class="line number45 index44 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* 4. Move the head to point to new Node */</code></div>
    <div class="line number46 index45 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">head = new_node;</code></div>
    <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number48 index47 alt1">&nbsp;</div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* This function prints contents of linked list</code></div>
    <div class="line number50 index49 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">starting from&nbsp; the given node */</code></div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">void</code> <code class="plain">printList()</code></div>
    <div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number53 index52 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">Node tnode = head;</code></div>
    <div class="line number54 index53 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">(tnode != </code><code class="keyword">null</code><code
            class="plain">)</code></div>
    <div class="line number55 index54 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number56 index55 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.print(tnode.data+</code><code class="string">"-&gt;"</code><code
            class="plain">);</code></div>
    <div class="line number57 index56 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">tnode = tnode.next;</code></div>
    <div class="line number58 index57 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number59 index58 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"NULL"</code><code class="plain">);</code>
    </div>
    <div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number61 index60 alt2">&nbsp;</div>
    <div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
            class="plain">main(String [] args)</code></div>
    <div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number64 index63 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">LinkedList llist = </code><code class="keyword">new</code> <code
            class="plain">LinkedList();</code></div>
    <div class="line number65 index64 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">(</code><code class="keyword">int</code> <code
            class="plain">i=</code><code class="value">5</code><code class="plain">; i&gt;</code><code
            class="value">0</code><code class="plain">; --i)</code></div>
    <div class="line number66 index65 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number67 index66 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">llist.push(i);</code></div>
    <div class="line number68 index67 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">llist.printList();</code></div>
    <div class="line number69 index68 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">llist.printMiddle();</code></div>
    <div class="line number70 index69 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number71 index70 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number72 index71 alt1"><code class="plain">&#125;</code></div>
    <div class="line number73 index72 alt2"><code class="comments">// This code is contributed by Rajat Mishra</code>
    </div>
</div>
        </div>
      <div id="tab-content-3" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments"># Python3 program to find middle of linked list</code>
    </div>
    <div class="line number2 index1 alt1"><code class="comments"># Node class</code></div>
    <div class="line number3 index2 alt2"><code class="keyword">class</code> <code class="plain">Node:</code></div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Function to initialise the node object</code></div>
    <div class="line number6 index5 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
            class="plain">, data):</code></div>
    <div class="line number7 index6 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.data </code><code class="keyword">=</code> <code
            class="plain">data&nbsp; </code><code class="comments"># Assign data</code></div>
    <div class="line number8 index7 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.</code><code class="functions">next</code> <code
            class="keyword">=</code> <code class="color1">None</code>&nbsp; <code
            class="comments"># Initialize next as null</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number11 index10 alt2"><code class="comments"># Linked List class contains a Node object</code>
    </div>
    <div class="line number12 index11 alt1"><code class="keyword">class</code> <code class="plain">LinkedList:</code>
    </div>
    <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number14 index13 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Function to initialize head</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">__init__(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number16 index15 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.head </code><code class="keyword">=</code> <code
            class="color1">None</code></div>
    <div class="line number17 index16 alt2">&nbsp;</div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Function to insert a new node at the beginning&nbsp;</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">push(</code><code class="color1">self</code><code
            class="plain">, new_data):&nbsp;</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node </code><code class="keyword">=</code> <code class="plain">Node(new_data)&nbsp;</code>
    </div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node.</code><code class="functions">next</code> <code class="keyword">=</code> <code
            class="color1">self</code><code class="plain">.head&nbsp;</code></div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1">self</code><code class="plain">.head </code><code class="keyword">=</code> <code
            class="plain">new_node</code></div>
    <div class="line number23 index22 alt2">&nbsp;</div>
    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Print the linked list</code></div>
    <div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">printList(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number26 index25 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node </code><code class="keyword">=</code> <code class="color1">self</code><code
            class="plain">.head</code></div>
    <div class="line number27 index26 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">node:</code></div>
    <div class="line number28 index27 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">(</code><code class="functions">str</code><code
            class="plain">(node.data) </code><code class="keyword">+</code> <code class="string">"-&gt;"</code><code
            class="plain">, end</code><code class="keyword">=</code><code class="plain">"")</code></div>
    <div class="line number29 index28 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">node </code><code class="keyword">=</code> <code class="plain">node.</code><code
            class="functions">next</code></div>
    <div class="line number30 index29 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions">print</code><code class="plain">(</code><code class="string">"NULL"</code><code
            class="plain">)</code></div>
    <div class="line number31 index30 alt2">&nbsp;</div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Function that returns middle.</code></div>
    <div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">def</code> <code class="plain">printMiddle(</code><code class="color1">self</code><code
            class="plain">):</code></div>
    <div class="line number34 index33 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Initialize two pointers, one will go one step a time (slow), another two at a time (fast)</code>
    </div>
    <div class="line number35 index34 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">slow </code><code class="keyword">=</code> <code class="color1">self</code><code
            class="plain">.head</code></div>
    <div class="line number36 index35 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">fast </code><code class="keyword">=</code> <code class="color1">self</code><code
            class="plain">.head</code></div>
    <div class="line number37 index36 alt2">&nbsp;</div>
    <div class="line number38 index37 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Iterate till fast's next is null (fast reaches end)</code></div>
    <div class="line number39 index38 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">while</code> <code class="plain">fast </code><code class="keyword">and</code> <code
            class="plain">fast.</code><code class="functions">next</code><code class="plain">:</code></div>
    <div class="line number40 index39 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">slow </code><code class="keyword">=</code> <code class="plain">slow.</code><code
            class="functions">next</code></div>
    <div class="line number41 index40 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">fast </code><code class="keyword">=</code> <code class="plain">fast.</code><code
            class="functions">next</code><code class="plain">.</code><code class="functions">next</code></div>
    <div class="line number42 index41 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number43 index42 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># return the slow's data, which would be the middle element.</code></div>
    <div class="line number44 index43 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">print</code><code class="plain">(</code><code
            class="string">"The middle element is "</code><code class="plain">, slow.data)</code></div>
    <div class="line number45 index44 alt2">&nbsp;</div>
    <div class="line number46 index45 alt1"><code class="comments"># Code execution starts here</code></div>
    <div class="line number47 index46 alt2"><code class="keyword">if</code> <code class="plain">__name__</code><code
            class="keyword">=</code><code class="keyword">=</code><code class="string">'__main__'</code><code
            class="plain">:</code></div>
    <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments"># Start with the empty list</code></div>
    <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">llist </code><code class="keyword">=</code> <code class="plain">LinkedList()</code></div>
    <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
    <div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
            class="functions">range</code><code class="plain">(</code><code class="value">5</code><code
            class="plain">, </code><code class="value">0</code><code class="plain">, </code><code
            class="keyword">-</code><code class="value">1</code><code class="plain">):</code></div>
    <div class="line number53 index52 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">llist.push(i)</code></div>
    <div class="line number54 index53 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">llist.printList()</code></div>
    <div class="line number55 index54 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">llist.printMiddle()</code></div>
    <div class="line number56 index55 alt1">&nbsp;</div>
    <div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;</code><code
            class="comments"># Code is contributed by Kumar Shivam (kshivi99)</code></div>
</div>
        </div>
     
       
      <div id="tab-content-4" class="tab-content">
      <div class="container">
    <div class="line number1 index0 alt2"><code class="comments">// C program to find middle of linked list</code></div>
    <div class="line number2 index1 alt1"><code class="preprocessor">#include&lt;stdio.h&gt;</code></div>
    <div class="line number3 index2 alt2"><code class="preprocessor">#include&lt;stdlib.h&gt;</code></div>
    <div class="line number4 index3 alt1">&nbsp;</div>
    <div class="line number5 index4 alt2"><code class="comments">/* Link list node */</code></div>
    <div class="line number6 index5 alt1"><code class="keyword bold">struct</code> <code class="plain">Node</code></div>
    <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">data;</code></div>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* next;</code></div>
    <div class="line number10 index9 alt1"><code class="plain">&#125;;</code></div>
    <div class="line number11 index10 alt2">&nbsp;</div>
    <div class="line number12 index11 alt1"><code
            class="comments">/* Function to get the middle of the linked list*/</code></div>
    <div class="line number13 index12 alt2"><code class="keyword bold">void</code> <code
            class="plain">printMiddle(</code><code class="keyword bold">struct</code> <code
            class="plain">Node *head)</code></div>
    <div class="line number14 index13 alt1"><code class="plain">&#123;</code></div>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node *slow_ptr = head;</code></div>
    <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node *fast_ptr = head;</code></div>
    <div class="line number17 index16 alt2">&nbsp;</div>
    <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">if</code> <code class="plain">(head!=NULL)</code></div>
    <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number20 index19 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code
            class="plain">(fast_ptr != NULL &amp;&amp; fast_ptr-&gt;next != NULL)</code></div>
    <div class="line number21 index20 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
    </div>
    <div class="line number22 index21 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">fast_ptr = fast_ptr-&gt;next-&gt;next;</code></div>
    <div class="line number23 index22 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">slow_ptr = slow_ptr-&gt;next;</code></div>
    <div class="line number24 index23 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
    </div>
    <div class="line number25 index24 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code
            class="string">"The middle element is [%d]\n\n"</code><code class="plain">, slow_ptr-&gt;data);</code></div>
    <div class="line number26 index25 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number27 index26 alt2"><code class="plain">&#125;</code></div>
    <div class="line number28 index27 alt1">&nbsp;</div>
    <div class="line number29 index28 alt2"><code class="keyword bold">void</code> <code class="plain">push(</code><code
            class="keyword bold">struct</code> <code class="plain">Node** head_ref, </code><code
            class="color1 bold">int</code> <code class="plain">new_data)</code></div>
    <div class="line number30 index29 alt1"><code class="plain">&#123;</code></div>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* allocate node */</code></div>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* new_node =</code></div>
    <div class="line number33 index32 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">(</code><code class="keyword bold">struct</code> <code class="plain">Node*) </code><code
            class="functions bold">malloc</code><code class="plain">(</code><code
            class="keyword bold">sizeof</code><code class="plain">(</code><code class="keyword bold">struct</code> <code
            class="plain">Node));</code></div>
    <div class="line number34 index33 alt1">&nbsp;</div>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* put in the data */</code></div>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node-&gt;data = new_data;</code></div>
    <div class="line number37 index36 alt2">&nbsp;</div>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* link the old list off the new node */</code></div>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">new_node-&gt;next = (*head_ref);</code></div>
    <div class="line number40 index39 alt1">&nbsp;</div>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* move the head to point to the new node */</code></div>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">(*head_ref) = new_node;</code></div>
    <div class="line number43 index42 alt2"><code class="plain">&#125;</code></div>
    <div class="line number44 index43 alt1">&nbsp;</div>
    <div class="line number45 index44 alt2"><code
            class="comments">// A utility function to print a given linked list</code></div>
    <div class="line number46 index45 alt1"><code class="keyword bold">void</code> <code
            class="plain">printList(</code><code class="keyword bold">struct</code> <code
            class="plain">Node *ptr)</code></div>
    <div class="line number47 index46 alt2"><code class="plain">&#123;</code></div>
    <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">while</code> <code class="plain">(ptr != NULL)</code></div>
    <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number50 index49 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d-&gt;"</code><code
            class="plain">, ptr-&gt;data);</code></div>
    <div class="line number51 index50 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">ptr = ptr-&gt;next;</code></div>
    <div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="functions bold">printf</code><code class="plain">(</code><code class="string">"NULL\n"</code><code
            class="plain">);</code></div>
    <div class="line number54 index53 alt1"><code class="plain">&#125;</code></div>
    <div class="line number55 index54 alt2">&nbsp;</div>
    <div class="line number56 index55 alt1"><code class="comments">/* Driver program to test above function*/</code>
    </div>
    <div class="line number57 index56 alt2"><code class="color1 bold">int</code> <code class="plain">main()</code></div>
    <div class="line number58 index57 alt1"><code class="plain">&#123;</code></div>
    <div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comments">/* Start with the empty list */</code></div>
    <div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">struct</code> <code class="plain">Node* head = NULL;</code></div>
    <div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="color1 bold">int</code> <code class="plain">i;</code></div>
    <div class="line number62 index61 alt1">&nbsp;</div>
    <div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">for</code> <code class="plain">(i=5; i&gt;0; i--)</code></div>
    <div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div>
    <div class="line number65 index64 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">push(&amp;head, i);</code></div>
    <div class="line number66 index65 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">printList(head);</code></div>
    <div class="line number67 index66 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">printMiddle(head);</code></div>
    <div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number69 index68 alt2">&nbsp;</div>
    <div class="line number70 index69 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keyword bold">return</code> <code class="plain">0;</code></div>
    <div class="line number71 index70 alt2"><code class="plain">&#125;</code></div>
</div>
        </div>
        </div>
  </div>
        </div>
        </div>
    )
}

export default Smsung5
